<template><svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg"><path stroke="#fff" stroke-width="2" d="M8 0v16M0 8h16"/></svg></template>